import { Component } from 'react';
import styles from './ModalHeader.module.scss';

interface IModalHeaderProps {
	title: string;
	close: () => void;
	onBack?: () => void;
	showBack?: boolean;
	beforeClose?: () => void;
}

export default class ModalHeader extends Component<IModalHeaderProps> {
	closeHandler() {
		const { close, beforeClose } = this.props;

		if (beforeClose) {
			beforeClose();
		}
		close();
	}

	render() {
		const { title, onBack, showBack } = this.props;

		return (
			<div className={styles.header}>
				{onBack && showBack ? <span className={styles.back} onClick={onBack} /> : null}
				{title}
				<span className={styles.close} onClick={this.closeHandler.bind(this)} />
			</div>
		);
	}
}
